import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';
import {DatiRitenutaItem} from '../../../../../domain/dati-ritenuta-item';

class RitenutaAccontoPAModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    'store',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack',
    '$uibModal',
    'configuration',
    '$sce'
  ];

  private close: any;
  private datiRitenutaItem: DatiRitenutaItem;
  private items: Array<DatiRitenutaItem>;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $state: ng.ui.IStateService,
    private store: ng.a0.storage.IStoreService,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $uibModalStack: ng.ui.bootstrap.IModalStackService,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private configuration: any,
    private $sce: ng.ISCEService
  ) {
    this.items = $scope.$parent.$resolve.items || [];
    /* tslint:disable:no-string-literal */
    $scope.TipoRitenutaType = {
      'RT01': 'RT01 - Ritenuta di acconto persone fisiche',
      'RT02': 'RT02 - Ritenuta di acconto persone giuridiche',
      'RT03': 'RT03 - Contributo INPS',
      'RT04': 'RT04 - Contributo ENASARCO',
      'RT05': 'RT05 - Contributo ENPAM',
      'RT06': 'RT06 - Altro contributo previdenziale'
    };

    $scope.CausalePagamentoType = {
      'A': 'A - Prestazioni di lavoro autonomo rientranti nell’esercizio di arte o professione abituale',
      'B': 'B - Utilizzazione economica, da parte dell’autore o dell’inventore, di opere dell’ingegno, di brevetti industriali e di processi, formule o informazioni relativi a esperienze acquisite in campo industriale, commerciale o scientifico',
      'C': 'C - Utili derivanti da contratti di associazione in partecipazione e da contratti di cointeressenza, quando l’apporto è costituito esclusivamente dalla prestazione di lavoro',
      'D': 'D - Utili spettanti ai soci promotori e ai soci fondatori delle società di capitali',
      'E': 'E - Levata di protesti cambiari da parte dei segretari comunali',
      'G': 'G - Indennità corrisposte per la cessazione di attività sportiva professionale',
      'H': 'H - Indennità corrisposte per la cessazione dei rapporti di agenzia delle persone fisiche e delle società di persone, con esclusione delle somme maturate entro il 31.12.2003, già imputate per competenza e tassate come reddito d’impresa',
      'I': 'I - Indennità corrisposte per la cessazione da funzioni notarili',
      'L': 'L - Utilizzazione economica, da parte di soggetto diverso dall’autore o dall’inventore, di opere dell’ingegno, di brevetti industriali e di processi, formule e informazioni relative a esperienze acquisite in campo industriale, commerciale o scientifico',
      'M': 'M - Prestazioni di lavoro autonomo non esercitate abitualmente, obblighi di fare, di non fare o permettere',
      'N': 'N - Indennità di trasferta, rimborso forfetario di spese, premi e compensi erogati : .. nell’esercizio diretto di attività sportive dilettantistiche',
      'O': 'O - Prestazioni di lavoro autonomo non esercitate abitualmente, obblighi di fare, di non fare o permettere, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. Inps 104/2001)',
      'P': 'P - Compensi corrisposti a soggetti non residenti privi di stabile organizzazione per l’uso o la concessione in uso di attrezzature industriali, commerciali o scientifiche che si trovano nel territorio dello',
      'Q': 'Q - Provvigioni corrisposte ad agente o rappresentante di commercio monomandatario',
      'R': 'R - Provvigioni corrisposte ad agente o rappresentante di commercio plurimandatario',
      'S': 'S - Provvigioni corrisposte a commissionario',
      'T': 'T - Provvigioni corrisposte a mediatore',
      'U': 'U - Provvigioni corrisposte a procacciatore di affari',
      'V': 'V - Provvigioni corrisposte a incaricato per le vendite a domicilio e provvigioni corrisposte a incaricato per la vendita porta a porta e per la vendita ambulante di giornali quotidiani e periodici (L. 25.02.1987, n. 67)',
      'W': 'W - Corrispettivi erogati nel 2013 per prestazioni relative a contratti d’appalto cui si sono resi applicabili le disposizioni contenute nell’art. 25-ter D.P.R. 600/1973',
      'X': 'X - Canoni corrisposti nel 2004 da società o enti residenti, ovvero da stabili organizzazioni di società estere di cui all’art. 26-quater, c. 1, lett. a) e b) D.P.R. 600/1973, a società o stabili organizzazioni di società, situate in altro Stato membro dell’Unione Europea in presenza dei relativi requisiti richiesti, per i quali è stato effettuato nel 2006 il rimborso della ritenuta ai sensi dell’art. 4 D. Lgs. 143/2005',
      'Y': 'Y - Canoni corrisposti dal 1.01.2005 al 26.07.2005 da soggetti di cui al punto precedente',
      'ZO': 'ZO - Titolo diverso dai precedenti',
      'L1': 'L1 - Redditi derivanti dall’utilizzazione economica di opere dell’ingegno, di brevetti industriali e di processi, che sono percepiti da soggetti che abbiano acquistato a titolo oneroso i diritti alla loro utilizzazione.',
      'M1': 'M1 - Redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere.',
      'M2': 'M2 - Prestazioni di lavoro autonomo non esercitate abitualmente per le quali sussiste l’obbligo di iscrizione alla Gestione Separata ENPAPI.',
      'O1': 'O1 - Redditi derivanti dall’assunzione di obblighi di fare, di non fare o permettere, per le quali non sussiste l’obbligo di iscrizione alla gestione separata (Circ. INPS n. 104/2001).',
      'V1': 'V1 - Redditi derivanti da attività commerciali non esercitate abitualmente (ad esempio, provvigioni corrisposte per prestazioni occasionali ad agente o rappresentante di commercio, mediatore, procacciatore d’affari);',
    };

    $scope.TipoImponibileImporto = {
      'TotaleLinee': 'Totale Linee',
      'ValorePersonalizzato': 'Valore personalizzato'
    };

    this.datiRitenutaItem = {
      'TipoRitenuta': '',
      'TipoImponibileImporto': 'TotaleLinee',
      'ImponibileImporto': '0.00',
      'AliquotaImporto': '100',
      'ImportoRitenuta': '0.00',
      'AliquotaRitenuta': '20.00',
      'CausalePagamento': ''
    };

    $scope.save = (errors) => {
      if ($.isEmptyObject(errors)) {
        // if ($scope.items && $scope.items.length>0) {
        //     $scope.item.CausalePagamento = $scope.item.CausalePagamentoObject.value;
        //     delete ($scope.item.CausalePagamentoObject);
        //     this.close({ $value: $scope.item });
        // } else {
        //     this.close({ $value: {} });
        // }
        this.close({ $value: this.items });
      } else {
        $rootScope.setErrorFieldsTouched(errors);
        $('[name=\'form\']').find('.ng-invalid:visible:first').focus();
      }
    };
    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };
    $scope.cancel = () => {
      this.close();
    };
    $scope.popover1 = $sce.trustAsHtml(
      '<br/><br/> Da compilare quando sei soggetto a ritenuta a titolo di acconto o a titolo definitivo<br/>');

    $scope.isAliquotaFrom50Percent = (datiRitenuta: DatiRitenutaItem) => {
      return datiRitenuta.TipoRitenuta === 'RT01'
        && ['Q', `R`, `S`, `T`, `U`, `V`].includes(datiRitenuta.CausalePagamento);
    };

    $scope.setAliquota = (item: DatiRitenutaItem) => {
      if ($scope.isAliquotaFrom50Percent(item)) {
        item.AliquotaImporto = '50.00';
      } else {
        item.AliquotaImporto = '100.00';
      }

      if (item.TipoRitenuta === 'RT04') {
        item.AliquotaRitenuta = '8.50';
      } else {
          item.AliquotaRitenuta = '20.00';
      }
    };
  }

  aggiungiDatiRitenuta() {
    this.items.push(jQuery.extend(true, {}, this.datiRitenutaItem));
  }

  rimuoviDatiRitenuta(index: number) {
    let modalInstance = this.$uibModal.open({
      component: 'defaultModalComponent',
      windowClass: 'center-modal',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        config: () => {
          return {
            headerIcon: 'fa fa-exclamation-triangle',
            headerText: 'Attenzione',
            bodyHtml: '<i class=\'fa fa-exclamation-triangle\'></i> Sei sicuro di voler cancellare Dati Ritenuta?',
            buttons: [
              {
                'id': 1,
                'icon': 'fa fa-ban',
                'label': 'Annulla'
              },
              {
                'id': 2,
                'icon': 'fa fa-check-circle-o',
                'label': 'Si'
              }
            ]
          };
        }
      }
    });
    modalInstance.result.then((pressedButtonId) => {
      if (pressedButtonId !== undefined) {
        if (pressedButtonId === 1) {
          // ??
        }
        if (pressedButtonId === 2) {
          this.items.splice(index, 1);
        }
      }
    }, () => {
      // ?
    });
  }
}

export const RitenutaAccontoPAModalComponent: ng.IComponentOptions = {
  template: require('./ritenuta-acconto-pa-modal.html'),
  controller: RitenutaAccontoPAModalController,
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/ritenuta-acconto-pa-modal/ritenuta-acconto-pa-modal.ts